import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import UpgradeContractFormService from '../services/UpgradeContractFormService';
import UpgradeContractForm from './UpgradeContractForm';

class UpgradeContractFormContainer extends React.Component {
  static propTypes = {
    contractId: PropTypes.string,
  };

  componentDidMount() {
    if (this.props.contractId) {
      UpgradeContractFormService.init(this.props.contractId);
    }
  }

  render() {
    return (
      <UpgradeContractForm
        onReset={UpgradeContractFormService.form.reset}
        contractType={toJS(UpgradeContractFormService.contract.type)}
        onChange={UpgradeContractFormService.form.setValue}
        onSubmit={UpgradeContractFormService.handleUpgrade}
        values={UpgradeContractFormService.form.getValues()}
        disabled={UpgradeContractFormService.fetch.fetching || UpgradeContractFormService.submit.fetching}
        loading={UpgradeContractFormService.fetch.fetching}
        submitting={UpgradeContractFormService.submit.fetching}
        errors={UpgradeContractFormService.form.errors}
        onAddProduct={UpgradeContractFormService.productsService.handleToggleModal}
      />
    );
  }
}

export default observer(UpgradeContractFormContainer);
